// Constants
export const DEVICE_MODES = {
  mobile: "mobile",
  desktop: "desktop",
} as const;

export const EDITOR_ELEMENTS = {
  title: "title",
  subTitle: "subTitle",
  buttons: "buttons",
  image: "image",
  align: "align",
} as const;

export type EditorElement =
  (typeof EDITOR_ELEMENTS)[keyof typeof EDITOR_ELEMENTS];

/**
 * Подписи элементов редактора обложки — общая мапа ключей для тулбара
 * (EditorToolbar) и заголовка боковой панели (EditDrawer).
 */
export const EDITOR_ELEMENT_LABEL_KEYS: Record<EditorElement, string> = {
  [EDITOR_ELEMENTS.title]: "platformCustomCovers.element.title",
  [EDITOR_ELEMENTS.subTitle]: "platformCustomCovers.element.subTitle",
  [EDITOR_ELEMENTS.buttons]: "platformCustomCovers.element.buttons",
  [EDITOR_ELEMENTS.image]: "platformCustomCovers.element.image",
  [EDITOR_ELEMENTS.align]: "platformCustomCovers.element.align",
};

export const DEFAULT_ALIGN = "center" as const;
